/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { gsap } from '@/lib/gsap';

export const useGsapContext = (func: gsap.ContextFunc, deps: any[] = []) => {
    useEffect(() => {
        const ctx = gsap.context(func);

        return () => {
            ctx?.revert();
        };
    }, deps);
};
